module.exports = __webpack_public_path__ + "img/compatilibty-wifi-6.3eee262f.webp";